import angular from "angular";
import template from "./admin-campus-create-vehicle.html";
import AdminSchoolLocationViewVehiclesCreateController from "./admin-campus-create-vehicle.controller";
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state(
    "drivecoach.admin.schools.view.locations.view.vehicles.create",
    {
      url: "/add-vehicle",
      controller: AdminSchoolLocationViewVehiclesCreateController,
      controllerAs: "vm",
      template: template,
      data: {
        authorizedRoles: [
          USER_ROLES.admin,
          USER_ROLES.administrator,
          USER_ROLES.owner,
        ],
      },
    },
  );
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.dashboard.schools.view.locations.view.vehicles.create", [])
  .config(config)
  .controller(
    "AdminSchoolLocationViewVehiclesCreateController",
    AdminSchoolLocationViewVehiclesCreateController,
  );
